export default {
  delay: 1000,
};
